
import FullLayout from './FullLayout'
import StudentJoinShortCode from './StudentJoinShortCode'

const StudentJoinShortCodeUnauthenticated = () => {


  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
        <FullLayout.Logo />
        <StudentJoinShortCode />
    </div>
  )
}

export default StudentJoinShortCodeUnauthenticated
